import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import no_user from "../public/assets/img/no_user.png";
import Breadcrumb from "../Breadcrumb";
import MetaHelmet from "../MetaHelmet";
import DeleteConfirmationModal from "../DeleteConfirmationModal";

const StaffIndex = () => {
  const [staffList, setStaffList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [staffToDelete, setStaffToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const token = localStorage.getItem("token");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const navigate = useNavigate();

  const routes = [
    { name: "Home", path: "/dashboard" },
    { name: "Staff", path: "/staff" },
  ];

  const roleMapping = {
    1: "Admin",
    2: "Affiliate",
    3: "Staff"
  };

  useEffect(() => {
    fetchStaff();
  }, [searchTerm, currentPage, location.pathname]);

  useEffect(() => {
      if (showDeleteModal) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    }, [showDeleteModal]);

  const fetchStaff = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}get-users`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { search: searchTerm, page: currentPage, per_page: 10 },
      });
      setStaffList(response.data.users || []);
      setTotalPages(Math.ceil(response.data.total / 10));
      setTotalEntries(response.data.total);
    } catch (error) {
      console.error("Error fetching staff:", error);

    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (id) => {
    navigate(`/staff/update/${id}`);
  };
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleClick = () => {
    navigate('/staff/create')
  }
  const handleDelete = async () => {
    if (!staffToDelete) return;
    try {
      const response = await axios.delete(`${API_BASE_URL}delete-user/${staffToDelete}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.status === "success") {
        toast.success("Staff deleted successfully");
        fetchStaff();
        setShowDeleteModal(false);
      } else {
        throw new Error(response.data.message || "Failed to delete staff member");
      }
    } catch (error) {
      console.error("Error deleting staff:", error);
      toast.error(error.response?.data?.message || "Failed to delete staff member");
    }
  };

  const openDeleteModal = (id) => {
    setStaffToDelete(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setStaffToDelete(null);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  if (loading) {
    return (
      <div id="loader-wrapper">
        <span className="loader"></span>
      </div>
    );
  }


  return (
    <><MetaHelmet title={`Local Shouts | Staff`} />
      <div className="container mt-4 staff-index" id="staff-index">
        <Breadcrumb routes={routes}></Breadcrumb>
        <div className="d-flex bg-white p-3 rounded-2 white-box-shadow">
          <div class="form-group search-bar d-flex">
            <input
              type="text"
              placeholder="Search by Staff name"
              value={searchTerm}
              onChange={handleSearch}
              class="form-control bg-light-gray border-0 py-2"
            />
            <div className="input-reset-div d-flex px-2 ms-3" onClick={() => setSearchTerm('')}>
              <svg fill="#000000" width="20px" height="20px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" class="input-reset">
                <path d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0" fill-rule="evenodd" />
              </svg>
            </div>
          </div>
          <div className="action-bar ms-auto align-content-center">
            <button className="btn ls-btn main-btn" onClick={handleClick}>
              <FaPlus />&nbsp;Create
            </button>
          </div>
          <ToastContainer />
        </div>

        <div className="table-responsive mt-3">
          <table className="table table-hover rounded-table white-box-shadow">
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {staffList.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">No records found</td>
                </tr>
              ) : (
                staffList.map((staff) => (
                  <tr key={staff.id}>
                    <td className="profile-picture">
                      <img
                        src={staff.image_url ? staff.image_url : no_user}
                        alt={staff.name}
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          objectFit: "cover"
                        }}
                      />
                    </td>
                    <td className="name">{staff.name}</td>
                    <td className="email">{staff.email}</td>
                    <td className="role">{roleMapping[staff.role_id] || "N/A"}</td>
                    <td className="action-btns">
                      <button
                        className="edit-btn action-btn btn ps-0"
                        onClick={() => handleEdit(staff.id)}
                      >
                        <FaEdit />
                      </button>
                      <button
                        className="delete-btn action-btn btn ps-0"
                        onClick={() => openDeleteModal(staff.id)}
                      >
                        <FaTrashAlt />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="pagination d-flex justify-content-between align-items-center mt-3">
          <div class="entry-summary">
            Showing {totalEntries === 0 ? 0 : ((currentPage - 1) * 10) + 1} to{" "}
            {((currentPage - 1) * 10) + staffList.length} out of {totalEntries} entries
          </div>
          {/* <div className="page-numbers">
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
            ))}
          </div> */}

          <ul className="page-numbers ps-0 mb-0">
            {[...Array(totalPages)].map((_, index) => (
              <li>
              <button
                key={index + 1}
                className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
              </li>
            ))}
          </ul>
        </div>

        {
        showDeleteModal && (
          <DeleteConfirmationModal
            onConfirm={handleDelete}
            onCancel={closeDeleteModal}
          />
        )
      }

      </div>
    </>
  );
};

export default StaffIndex;
